//LOGIN
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATING = 'AUTHENTICATING';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';
export const RESETTING_PASSWORD = 'RESETTING_PASSWORD';
export const PASSWORD_RESET = 'PASSWORD_RESET';
export const RESET_ERROR = 'RESET_ERROR';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const SET_REDIRECT_TO = 'SET_REDIRECT_TO';

//USER
export const FETCH_USER = 'FETCH_USER';
export const SAVE_INSTALL_APP_DETAILS_UNTIL_LOGIN = 'SAVE_INSTALL_APP_DETAILS_UNTIL_LOGIN';
export const CLEAR_INSTALL_APP_DETAILS = 'CLEAR_INSTALL_APP_DETAILS';

//APPS
export const LOADING_APPS = 'LOADING_APPS';
export const FETCH_APPS = 'FETCH_APPS';
export const APP_INSTALLED = 'APP_INSTALLED';
export const APP_UNINSTALLED = 'APP_UNINSTALLED';
export const APP_UNINSTALLING = 'APP_UNINSTALLING';
export const GET_URL = 'GET_URL';
export const APP_RESETTING = 'APP_RESETTING';

//Notifications
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DISMISS_ALL_NOTIFICATIONS = 'DISMISS_ALL_NOTIFICATIONS';

//CONFIG/SETTINGS
export const CONFIG_OPEN = 'CONFIG_OPEN';
export const CONFIG_CLOSE = 'CONFIG_CLOSE';
export const SETTINGS_SAVING = 'SETTINGS_SAVING';
export const SETTINGS_SAVED = 'SETTINGS_SAVED';

//AUTHORISE
export const LOOKING_UP_AUTH_APP = 'LOOKING_UP_AUTH_APP';
export const AUTH_APP_EXISTS = 'AUTH_APP_EXISTS';
export const AUTH_APP_ERROR = 'AUTH_APP_ERROR';

//UPLOAD
export const UPLOAD_CONTACTS_CSV = 'UPLOAD_CONTACTS_CSV';

//UI
export const TOGGLE_FORM_MODAL = 'TOGGLE_FORM_MODAL';
export const POST_INSTALL_REQUIRED = 'POST_INSTALL_REQUIRED';


// WEBPACK FOOTER //
// ./src/actions/types.js